<template>
  <div class="page">
    <div class="row">
      <div class="sm-12">
        <div class="box-page">
          <div class="row">
            <div class="sm-12">
              <div class="title">
                <i class="mdi mdi-finance"></i>
                <h2>Gráficos</h2>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="sm-12 md-12">
              <GraficoDespesaReceita
                :codigo_condominio="codigo_condominio"
                :data_inicio="data_inicio"
                :data_fim="data_fim"></GraficoDespesaReceita>
            </div>
            <div class="sm-12 md-12">
              <GraficoResumoReceita
                :codigo_condominio="codigo_condominio"
                :data_inicio="data_inicio"
                :data_fim="data_fim"></GraficoResumoReceita>
            </div>
          </div>
          <div class="row">
            <div class="sm-12 md-12">
              <GraficoResumoDespesas
                :codigo_condominio="codigo_condominio"
                :data_inicio="data_inicio"
                :data_fim="data_fim"></GraficoResumoDespesas>
            </div>
            <div class="sm-12 md-12">
              <GraficoSaldoContaCorrente
                :codigo_condominio="codigo_condominio"
                :data_base="data_base"></GraficoSaldoContaCorrente>
            </div>
          </div>
          <div class="row">
            <div class="sm-12 md-12">
              <GraficoResumoBoletos
                :codigo_condominio="codigo_condominio"
                :ano="year"
                :mes="month"></GraficoResumoBoletos>
            </div>
            <div class="sm-12 md-12">
              <GraficoInadimplencia
                :codigo_condominio="codigo_condominio"
                :data_base="data_base"></GraficoInadimplencia>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GraficoDespesaReceita from "./GraficoDespesaReceita.vue";
import GraficoResumoReceita from "./GraficoResumoReceita.vue";
import GraficoResumoDespesas from "./GraficoResumoDespesas.vue";
import GraficoSaldoContaCorrente from "./GraficoSaldoContaCorrente.vue";
import GraficoResumoBoletos from "./GraficoResumoBoletos.vue";
import GraficoInadimplencia from "./GraficoInadimplencia.vue"; 

import { DateTime } from "luxon";
import { Datetime } from "vue-datetime";
export default {
  components: {
    GraficoDespesaReceita,
    GraficoResumoReceita,
    GraficoResumoDespesas,
    GraficoSaldoContaCorrente,
    GraficoResumoBoletos,
    GraficoInadimplencia,
  },
  data() {
    let year = +DateTime.local().toFormat("yyyy");
    let month = +DateTime.local().toFormat("LL");
    let data_inicio = DateTime.local().toFormat("yyyy-01-01");
    if (month == 1) {
      data_inicio = DateTime.local().toFormat(`${year - 1}-12-01`);
    }
    return {
      year,
      month,
      data_base: DateTime.local().toFormat("yyyy-LL-dd"),
      data_inicio: data_inicio,
      data_fim: DateTime.local().toFormat("yyyy-LL-dd"),
    };
  },
  computed: {
    condominio() {
      return this.$store.getters.condominio;
    },
    codigo_condominio() {
      if (!this.condominio) {
        return null;
      }
      return this.condominio.codigo;
    },
  },
};
</script>
